import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';
import Input, { InputLabel } from 'material-ui/Input';
import { MenuItem } from 'material-ui/Menu';
import { FormControl, FormHelperText } from 'material-ui/Form';
import Table, { TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel } from 'material-ui/Table';
import Select from 'material-ui/Select';

let id = 0;
function createData(age, userbase) {
  id += 1;
  return { id, age, userbase};
}

const data = [
  createData(35, 223),
  createData(36, 416),
  createData(37, 422),
  createData(38, 432),
  createData(39, 411),
  createData(40, 404),
  createData(41, 355),
  createData(42, 327),
  createData(43, 336),
  createData(44, 296),
  createData(45, 329),
  createData(46, 298),
  createData(47, 311),
  createData(48, 278),
  createData(49, 219),
  createData(50, 193),
  createData(51, 194),
  createData(52, 163),
  createData(53, 127),
  createData(54, 36),
];

class Q3 extends Component {

  constructor(props){
    super(props);

    this.state = {
      youngest: 35,
      oldest: 52,
      page: 0,
      rowsPerPage: 5,
      age: [35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65],
    };
  }

  componentDidMount() {
    //alert(JSON.stringify(data));
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  render(){
    const { classes, theme, location } = this.props;
    const { rowsPerPage, page } = this.state;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    return(
      <div className={classes.root}>
        <Typography>Heres a quick list of the users per respective age group:</Typography>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.alignment} numeric>Age</TableCell>
              <TableCell className={classes.alignment} numeric>Users Available</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
             {data.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map(n => {
               return (
                 <TableRow key={n.id}>
                   <TableCell className={classes.alignment}>{n.age}</TableCell>
                   <TableCell className={classes.alignment} numeric>{n.userbase}</TableCell>
                 </TableRow>
               );
             })}
             {emptyRows > 0 && (
               <TableRow style={{ height: 49 * emptyRows }}>
                 <TableCell colSpan={6} />
               </TableRow>
             )}
           </TableBody>
          <TableFooter>
              <TableRow>
                <TablePagination
                  count={data.length}
                  rowsPerPage={this.state.rowsPerPage}
                  page={this.state.page}
                  backIconButtonProps={{
                    'aria-label': 'Previous Page',
                  }}
                  nextIconButtonProps={{
                    'aria-label': 'Next Page',
                  }}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
        </Table>
        <div className={classes.buttonNext}>
          <Button raised onClick={() => this.props.changeRoute("/console/display/adhoc_filters/question3")}  color="primary" align="center" className={classes.button}>Go Back</Button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Q3)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/Adhoc/scenes/Distribution/Q3/index.js